import { useState, useCallback } from "react";
import { useFetch } from "../../../../utils/hooks/useFetch";
import {
  createOrEditResourcePayload,
  getResourceDetailsServiceConfig,
} from "../../../../utils/services/account";
import { DATE_TIME_FORMAT, TOAST_TIMER } from "../../../../utils/constants";
import moment from "moment";

export const useAccount = () => {
  const { isLoading, performAction } = useFetch();
  const [errorMessage, setErrorMessage] = useState("");
  const createOrUpdateResourceAccount = async (
    isCreateMode,
    resourceFormValues
  ) => {
    try {
      const { url, options } = createOrEditResourcePayload(
        isCreateMode,
        resourceFormValues
      );
      return await performAction(url, options);
    } catch (e) {
      console.error(e, "Error updating the resource");
      setErrorMessage(e.message);
      setTimeout(() => {
        setErrorMessage("");
      }, TOAST_TIMER);
    }
  };
  const hideErrorToast = useCallback(() => {
    setErrorMessage("");
  }, []);
  const fetchUserAccountDetails = useCallback(
    async (resourceId) => {
      try {
        const { url, options } = getResourceDetailsServiceConfig(resourceId);
        const response = await performAction(url, options);
        if (
          response &&
          typeof response === "object" &&
          typeof response.Result === "object"
        ) {
          debugger;
          const {
            AccountType,
            Address,
            CreatedOn,
            Email,
            Phone,
            ResourceName,
            Status,
            LastLogin,
          } = response.Result;
          const formattedResponse = {
            resourceType: AccountType,
            resourceName: ResourceName,
            resourceEmail: Email,
            resourceId: resourceId,
            resourceCreatedOn: moment(new Date(CreatedOn)).format(
              DATE_TIME_FORMAT.DISPLAY
            ),
            resourceLocation: Address,
            resourceLastLogin:
              LastLogin === null
                ? null
                : moment(new Date(LastLogin)).format(DATE_TIME_FORMAT.DISPLAY),
            resourcePhoneNumber: Phone,
            resourceStatus: Status,
          };
          return formattedResponse;
        }
        throw new Error("Unable to fetch resource details");
      } catch (e) {
        console.error(e, "Error fetching the resource");
        setErrorMessage(e.message);
        setTimeout(() => {
          setErrorMessage("");
        }, TOAST_TIMER);
      }
    },
    [performAction]
  );
  return {
    isLoading,
    createOrUpdateResourceAccount,
    hideErrorToast,
    fetchUserAccountDetails,
    errorMessage,
  };
};
